import { RootState } from 'reduxStore/types';

export const getExecutorsPageFilters = (state: RootState) => state?.orders.executorsPageFilters;
